import snakeCase from "lodash/fp/snakeCase";
import React from "react";
import ChevronDownIcon from "shared/components/icons/chevron/ChevronDownIcon";
import CrossIcon from "shared/components/icons/sign/CrossIcon";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarModalBody from "shared/components/pillar-modal/NewPillarModalBody";
import { usePillarModalControl } from "shared/components/pillar-modal/usePillarModalControl";
import type { MenuItemDisclosureProps } from "hub/src/components/sideMenu/HubSideMenuItem";

const HubSideMenuItemModal = ({
  label,
  initialIsOpen = false,
  children,
  buttonClassName,
  panelClassName,
  chevronIconClassname,
  className,
  IconComponent,
}: MenuItemDisclosureProps) => {
  const modalControl = usePillarModalControl();

  return (
    <div className={className}>
      <PillarForm.Button
        data-testid={`main-menu-${snakeCase(label)}`}
        className={`sidebar-menu-selector ${buttonClassName}`}
        onClick={() => modalControl.setIsOpen(true)}
      >
        {IconComponent && (
          <IconComponent className="sidebar-menu-svg ion-like-icon" />
        )}
        <div className="sidebar-menu-title">{label}</div>
        <span>
          <ChevronDownIcon
            className={`${
              modalControl.isOpen ? "rotate-180 transform" : ""
            } ${chevronIconClassname}`}
          />
        </span>
      </PillarForm.Button>

      <PillarModalBody
        control={modalControl}
        className="sidebar-menu-modal"
        containerClasses="phone:overscroll-none"
        dialogPanelWrapperClasses="phone:max-h-full"
      >
        <div className="sidebar-menu-modal-header">
          <h3 className="appmodal-panel-title flex justify-center col-start-2">
            {label}
          </h3>

          <PillarForm.Button
            className="button-regular-general-unfilled size-6 rounded-full col-start-3 absolute right-0 top-1/2 -translate-y-1/2"
            onClick={() => modalControl.setIsOpen(false)}
          >
            <CrossIcon className="size-3" />
          </PillarForm.Button>
        </div>

        <div className={`p-2 phone:px-4 ${panelClassName}`}>{children}</div>
      </PillarModalBody>
    </div>
  );
};

export default HubSideMenuItemModal;
